var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 150,
    viewBox: "0 0 520 150",
    overflow: "visible",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "       M 16 0.5       H 504       Q 519.5 0.5 519.5 16       V 112       Q 519.5 127.5 504 127.5       H 410       L 382 149.5       L 354 127.5       H 16       Q 0.5 127.5 0.5 112       V 16       Q 0.5 0.5 16 0.5       Z     ",
    fill: "#F6F6F6",
    stroke: "#4c7d9f",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubble);
export default __webpack_public_path__ + "static/media/chat-bubble.a3e6fd914499ad08c4f7f24aefc0e7ea.svg";
export { ForwardRef as ReactComponent };